import { PureAbility } from '@casl/ability';

const MyAbility = new PureAbility([]);

export default MyAbility;